import BodyFormStockRun from './components/BodyFormStockRun';

const AddStockRunPage = () => {
  return <BodyFormStockRun />;
};

export default AddStockRunPage;
